import React from "react";
import {Box} from "@mui/material";
import {BottomNavbarButton} from "../../../../designSystem/components/BottomNavbarButton";

export const BottomNavbar = ({
  buttons,
  selectedTab = '',
  lightShadow = false,
}) => (
  <Box className={`
    left-0 w-full bg-white flex justify-evenly items-center px-6 py-0
    ${lightShadow ? 'shadow-md shadow-blue-100' : 'shadow-2xl shadow-blue-300'}
  `}>
    {buttons.map(button => (
      <BottomNavbarButton
        key={button.name}
        label={button.label}
        icon={button.icon}
        selected={selectedTab === button.name}
        onClick={button.onClick}
      />
    ))}
  </Box>
)
